import script from "./DefaultManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefaultManage.vue?vue&type=script&lang=ts&setup=true"

import "./DefaultManage.vue?vue&type=style&index=0&id=7314d4d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7314d4d8"]])

export default __exports__